import { ApiConnector } from 'Connectors/ApiConnector';
import ConfigProxy      from 'tools/ConfigProxy';
import AbstractApiModel from './AbstractApiModel';

export const suggestionConnector = new ApiConnector({
	baseURL: ConfigProxy.getServiceConfig('suggestion', 'api_endpoint'),
});

export default class SuggestionApiModel extends AbstractApiModel {
	public static get connector() {
		return suggestionConnector;
	}

	public static serviceName: ServiceName = 'suggestion';
}
